import React, { FC, useMemo } from "react";
import { PieChart as UIPieChart } from "@evergis/charts";
import { Icon } from "@evergis/ui";

import { PieChartContainer, PieChartIcon, PieChartLegendContainer, PieChartWrapper } from "./styled";
import { Legend } from "./Legend";

import { getGradientColors } from "./utils/getGradientColors";

import { ChatChartProps } from "./types";

export const PieChart: FC<ChatChartProps> = ({ chartData }) => {
  const gradientColors = useMemo(() => {
    return getGradientColors(chartData.labels.length);
  }, [chartData]);

  const data = useMemo(() => {
    return chartData.labels.map((item, itemIndex) => ({
      name: item,
      value: chartData.datasets[0].data[itemIndex],
      color: gradientColors[itemIndex],
    }));
  }, [chartData, gradientColors]);

  const legend = useMemo(() => {
    return data.map(item => ({
      name: item.name,
      color: item.color,
    }));
  }, [data]);

  return (
    <PieChartWrapper>
      <PieChartContainer>
        <UIPieChart
          data={data}
          outerRadius={0.7}
          height={160}
          width={160}
          startAngle={20}
          padAngle={1}
          cornerRadius={2}
        >
          <PieChartIcon>
            <Icon kind="pulse" />
          </PieChartIcon>
        </UIPieChart>
      </PieChartContainer>
      <PieChartLegendContainer>
        <Legend items={legend} />
      </PieChartLegendContainer>
    </PieChartWrapper>
  );
};
